import type { Resources } from './pl'

const en: Resources = {
  common: {
    appName: 'ONITSOFT Trucking',
    play: 'Play',
    playAgain: 'Play again',
    home: 'Start screen',
    bookDemo: 'Book a demo',
    back: 'Back',
    close: 'Close',
    points: 'points',
    pts: 'pts',
    best: 'Best',
    today: 'Today',
    you: 'You',
    rank: 'Rank',
    soundOn: 'Sound on',
    soundOff: 'Sound off',
    langPl: 'PL',
    langEn: 'EN',
  },
  start: {
    badge: 'ONITSOFT trade fair game',
    title: 'You drive the truck,',
    titleAccent: 'you dodge freight forwarding',
    subtitle:
      'Roadside inspection, traffic jam, closed exit, missing CMR and a customer who never pays. You drive until you hit something — Bobi and Sokar keep the route alive.',
    nameLabel: 'Your name',
    namePlaceholder: 'e.g. Kate',
    nameError: 'Enter a name — 2 to 24 characters.',
    startBtn: "Let's roll!",
    howTitle: 'How to play',
    howLane: 'Swipe left or right, or tap the left or right half of the screen.',
    howCollect: 'Grab orders for points and fuel to push your combo multiplier up.',
    howBobi: 'Bobi takes the wheel for 5 seconds and dodges obstacles for you.',
    howSokar: 'Sokar clears the road ahead and doubles your points for 8 seconds.',
    privacy: 'Your name stays on this phone and is only used to label your score.',
    boardTitle: "Today's best scores",
    boardEmpty: 'Nobody has driven yet. Be the first.',
  },
  hud: {
    score: 'Score',
    speed: 'km/h',
    combo: 'Combo',
    autopilot: 'Bobi autopilot',
    doubled: 'Double points',
  },
  entity: {
    itd: {
      name: 'Roadside inspection',
      hit: 'Roadside inspection? Bobi keeps your paperwork and deadlines in order 24/7.',
    },
    jam: {
      name: 'Traffic jam',
      hit: 'Jam ate your delivery slot? Bobi watches the route and warns you before the customer calls.',
    },
    closedExit: {
      name: 'Closed exit',
      hit: 'Exit closed? Sokar replans the route and the order before you lose the whole day.',
    },
    noCmr: {
      name: 'Missing CMR',
      hit: 'No CMR, no payment. Bobi makes sure every order has its full set of documents.',
    },
    badPayer: {
      name: 'Insolvent customer',
      hit: 'Insolvent customer? Bobi checks the VAT number and tax status before you take the load.',
    },
    order: { name: 'Order' },
    fuel: { name: 'Fuel' },
    bobi: { name: 'Bobi' },
    sokar: { name: 'Sokar Logistics' },
  },
  bubble: {
    start: "Rolling. Road's clear!",
    ready: 'Tap the screen and we go.',
    bobi: "Autopilot on. I'm driving.",
    bobiEnd: 'Wheel is yours again.',
    sokar: 'Sokar clears the road. Points x2!',
    nearMiss: 'That was close! Nice move.',
    combo: 'Combo is climbing. Keep it up.',
    fast: 'Some pace. Eyes on the road.',
    comboLost: 'Combo gone. Grab some fuel.',
  },
  over: {
    title: 'End of the road, {{name}}!',
    titleBest: "Today's record, {{name}}!",
    crashedBy: 'Stopped by: {{obstacle}}',
    scoreLabel: 'Your score',
    codeLabel: 'Verification code',
    codeHint: 'Show this code at the stand to confirm your score.',
    rankLabel: 'Rank {{rank}} today',
    personalBest: 'Your best score today',
    stats: {
      orders: 'Orders',
      fuel: 'Fuel',
      bobi: 'Bobi',
      sokar: 'Sokar',
      near: 'Near misses',
      distance: 'Distance',
      time: 'Time',
      topSpeed: 'Top speed',
    },
    prize: {
      title: 'Prizes at the stand',
      desc: 'We reward the best scores of the day at the ONITSOFT stand — show your score and verification code to the team. The board is stored on this phone, so what counts is what you show us in person.',
    },
    demo: {
      title: 'Bobi and Sokar for real',
      desc: 'In the game you dodge these problems by reflex — in daily freight forwarding Bobi and Sokar Logistics do it for you. Book a free demo and see it on your own orders.',
      qrHint: 'Scan the code with your phone or leave your e-mail below.',
      button: 'Book a free demo',
    },
    lead: {
      title: 'Prefer us to reach out?',
      desc: 'Leave your e-mail and we will set up a Bobi and Sokar demo. No newsletter.',
      email: 'E-mail',
      emailPlaceholder: 'name@company.com',
      phone: 'Phone (optional)',
      phonePlaceholder: '+48 600 000 000',
      consent:
        'I agree to the processing of my personal data by Onit Soft sp. z o.o., based in Kraków (data controller), in order to be contacted about a Bobi and Sokar Logistics demo. I can withdraw this consent at any time.',
      submit: 'Send',
      sending: 'Sending…',
      sent: 'Thanks! We will get in touch about the demo.',
      queued: 'You are offline — we will send it as soon as the connection is back.',
      error: 'Sending failed. Please try again.',
      invalidEmail: 'Enter a valid e-mail address.',
      consentRequired: 'Tick the consent box to send the form.',
    },
  },
  verify: {
    title: 'Score verification',
    subtitle: "Enter the code from the player's phone to check whether the score is genuine.",
    placeholder: 'TRK-XXXX',
    check: 'Check',
    valid: 'Code is valid',
    invalid: 'Invalid code — this score does not come from the game.',
    scoreLabel: 'Score: {{score}} pts',
  },
}

export default en
